// extracted by mini-css-extract-plugin
export default {"index-container":"MX7RMg7lH9RXGdOxMulQ","content":"noscL_19UNFXcIzvgnux"};